var map = {
	"./svg/docker.svg": 32268,
	"./svg/eslint.svg": 19195,
	"./svg/java.svg": 46856,
	"./svg/less.svg": 76203,
	"./svg/mybatis.svg": 50767,
	"./svg/mysq.svg": 17074,
	"./svg/nacos.svg": 34112,
	"./svg/npm.svg": 5851,
	"./svg/sass.svg": 8442,
	"./svg/springboot.svg": 82863,
	"./svg/springnew.svg": 32331,
	"./svg/taiwind.svg": 20784,
	"./svg/ts.svg": 70799,
	"./svg/vite.svg": 42194,
	"./svg/vue.svg": 87480,
	"./svg/webpack.svg": 94613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80347;